module.exports = __webpack_public_path__ + "static/media/7ICJ4.bab06f20.jpg";